import BaseAPI from '../base.js';
export default {
  dashboard(){
    return BaseAPI.Get("users/dashboard");
  }
}